import { Component, Input } from '@angular/core';
import { TooltipPosition } from '@ddt-web/dom';

@Component({
	selector: 'pi-alert',
	templateUrl: './alert.component.html',
	styleUrls: ['./alert.component.scss']
})
export class AlertComponent {
	@Input() public text: string;
	@Input() public infoBubble?: string;

	public TooltipPosition = TooltipPosition;
}
